import PaymentPlansAPI from './PaymentPlansAPI';
export default PaymentPlansAPI;
